var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.22,
    height: 17.987,
    viewBox: "0 0 15.22 17.987",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21252",
    "data-name": "Group 21252",
    transform: "translate(18748 14531.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-18748 -14531.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25702",
    "data-name": "Path 25702",
    d: "M15.318,9.005H10.893a.692.692,0,0,0,0,1.384h4.425a.692.692,0,1,0,0-1.384Z",
    transform: "translate(-3.836 2.067)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_743",
    "data-name": "Ellipse 743",
    cx: 0.829,
    cy: 0.829,
    rx: 0.829,
    ry: 0.829,
    transform: "translate(3.739 10.935)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25703",
    "data-name": "Path 25703",
    d: "M15.318,14.2H10.893a.692.692,0,0,0,0,1.384h4.425a.692.692,0,1,0,0-1.384Z",
    transform: "translate(-3.836 -6.726)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_744",
    "data-name": "Ellipse 744",
    cx: 0.829,
    cy: 0.829,
    rx: 0.829,
    ry: 0.829,
    transform: "translate(3.739 7.339)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25704",
    "data-name": "Path 25704",
    d: "M14.9,19.2H10.893a.692.692,0,0,0,0,1.384H14.9a.692.692,0,0,0,0-1.384Z",
    transform: "translate(-3.836 -15.185)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_745",
    "data-name": "Ellipse 745",
    cx: 0.829,
    cy: 0.829,
    rx: 0.829,
    ry: 0.829,
    transform: "translate(3.739 3.88)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25707",
    "data-name": "Path 25707",
    d: "M16.217,2.01H3.508A1.517,1.517,0,0,0,2,3.532V18.108a1.524,1.524,0,0,0,.815,1.356,1.488,1.488,0,0,0,1.544-.1A.935.935,0,0,1,5,19.153a1.06,1.06,0,0,1,.747.289,2.468,2.468,0,0,0,3.122,0,1.1,1.1,0,0,1,1.486,0,2.477,2.477,0,0,0,3.128,0,1.053,1.053,0,0,1,.739-.287.927.927,0,0,1,.633.209,1.486,1.486,0,0,0,1.549.109,1.52,1.52,0,0,0,.82-1.355V2.708a.692.692,0,1,0-1.384,0V18.115a.134.134,0,0,1-.074.127.093.093,0,0,1-.109-.007,2.29,2.29,0,0,0-1.436-.465,2.391,2.391,0,0,0-1.557.555,1.109,1.109,0,0,1-1.493,0,2.47,2.47,0,0,0-3.121,0,1.1,1.1,0,0,1-1.486,0A2.4,2.4,0,0,0,5,17.769a2.289,2.289,0,0,0-1.436.47.1.1,0,0,1-.1,0,.137.137,0,0,1-.073-.13V3.532a.134.134,0,0,1,.125-.139H16.217a.692.692,0,0,0,0-1.384Z",
    transform: "translate(-2 -2.01)",
    fill: "#b3b3b3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillIcon);
export default __webpack_public_path__ + "static/media/bill_icon.17c7b96f7ff62de89e044272af948b03.svg";
export { ForwardRef as ReactComponent };